import { BaseTypographyVariant } from './BaseTypographyVariant.ts';
import { colorPalette } from '../../ui-blocks/ColorPalette';

export const BaseTypographyConfig = {
	defaultVariantType: BaseTypographyVariant.Body1,
	defaultColor: colorPalette.light1,
	baseTypographyVariants: [
		BaseTypographyVariant.D1Light,
		BaseTypographyVariant.D1Regular,
		BaseTypographyVariant.D1Bold,

		BaseTypographyVariant.D1V2Light,
		BaseTypographyVariant.D1V2Regular,
		BaseTypographyVariant.D1V2Bold,

		BaseTypographyVariant.D2Light,
		BaseTypographyVariant.D2Regular,
		BaseTypographyVariant.D2Bold,

		BaseTypographyVariant.D2V2Light,
		BaseTypographyVariant.D2V2Regular,
		BaseTypographyVariant.D2V2Bold,

		BaseTypographyVariant.D3Light,
		BaseTypographyVariant.D3Regular,
		BaseTypographyVariant.D3Bold,

		BaseTypographyVariant.D3V2Light,
		BaseTypographyVariant.D3V2Regular,
		BaseTypographyVariant.D3V2Bold,

		BaseTypographyVariant.H1Regular,
		BaseTypographyVariant.H1Medium,
		BaseTypographyVariant.H1Bold,

		BaseTypographyVariant.H1V2Regular,
		BaseTypographyVariant.H1V2Medium,
		BaseTypographyVariant.H1V2Bold,

		BaseTypographyVariant.H2Regular,
		BaseTypographyVariant.H2Medium,
		BaseTypographyVariant.H2Bold,

		BaseTypographyVariant.H2V2Regular,
		BaseTypographyVariant.H2V2Medium,
		BaseTypographyVariant.H2V2Bold,

		BaseTypographyVariant.T1Regular,
		BaseTypographyVariant.T1Medium,
		BaseTypographyVariant.T1Bold,

		BaseTypographyVariant.T1V2Regular,
		BaseTypographyVariant.T1V2Medium,
		BaseTypographyVariant.T1V2Bold,

		BaseTypographyVariant.Body1,
		BaseTypographyVariant.T2Regular,
		BaseTypographyVariant.T2Medium,
		BaseTypographyVariant.T2Bold,

		BaseTypographyVariant.T2V2Regular,
		BaseTypographyVariant.T2V2Medium,
		BaseTypographyVariant.T2V2Bold,

		BaseTypographyVariant.B1Regular,
		BaseTypographyVariant.B1Medium,
		BaseTypographyVariant.B1Bold,

		BaseTypographyVariant.B1V2Regular,
		BaseTypographyVariant.B1V2Medium,
		BaseTypographyVariant.B1V2Bold,

		BaseTypographyVariant.B2Regular,
		BaseTypographyVariant.B2Medium,
		BaseTypographyVariant.B2Bold,

		BaseTypographyVariant.B2V2Regular,
		BaseTypographyVariant.B2V2Medium,
		BaseTypographyVariant.B2V2Bold,

		BaseTypographyVariant.B3Regular,
		BaseTypographyVariant.B3Medium,
		BaseTypographyVariant.B3Bold,

		BaseTypographyVariant.B3V2Regular,
		BaseTypographyVariant.B3V2Medium,
		BaseTypographyVariant.B3V2Bold,

		BaseTypographyVariant.B2Caption,
		BaseTypographyVariant.B2CaptionMedium,
		BaseTypographyVariant.B2CaptionBold,

		BaseTypographyVariant.Numbers,

		BaseTypographyVariant.TooltipRegular,
		BaseTypographyVariant.TooltipMedium,
		BaseTypographyVariant.TooltipBold,

		BaseTypographyVariant.TooltipV2Regular,
		BaseTypographyVariant.TooltipV2Medium,
		BaseTypographyVariant.TooltipV2Bold,

		BaseTypographyVariant.ND1,
		BaseTypographyVariant.ND2,
		BaseTypographyVariant.ND3,
		BaseTypographyVariant.NP1,
		BaseTypographyVariant.NP2,
		BaseTypographyVariant.NP3,
		BaseTypographyVariant.NS1,
		BaseTypographyVariant.NS2,
		BaseTypographyVariant.NL1,
		BaseTypographyVariant.NL2,
		BaseTypographyVariant.NT,

		BaseTypographyVariant.InfoText,
		BaseTypographyVariant.InputLabel,
		BaseTypographyVariant.AlertHeader,
	],
};
